document.addEventListener("DOMContentLoaded", function () {
	loadSlider();
});

function loadSlider() {
	const wrappers = document.querySelectorAll('.bonus-tiles');
	if (!wrappers) return;

	wrappers.forEach(wrapper => {
		const slider = wrapper.querySelector('.glide');
		if (!slider) return;

		const interval = wrapper.dataset.interval;
		const total = wrapper.dataset.count;
		let typeOfSlider = 'slider',
			focusAt = 0,
			autoplay = false,
			rewind = true,
			perView = 4


		if (total > 4) {
			typeOfSlider = 'carousel'
			focusAt = 0
			autoplay = interval
			perView = 5
		}

		console.log(interval);

		const glide = new Glide(slider, {
			type: typeOfSlider,
			perView: perView,
			gap: 0,
			perTouch: 1,
			autoplay: autoplay,
			rewind: rewind,
			focusAt: focusAt,
			bound: true,
			breakpoints: {
				930: {
					type: 'carousel',
					autoplay: interval,
					perView: 3,
				},
				767: {
					type: 'carousel',
					autoplay: interval,
					perView: 2,
				},
				500: {
					type: 'carousel',
					autoplay: interval,
					animationDuration: 200,
					perView: 1.5,
				},
			},
		})

		glide.mount();
	});

}
